export const MODEL_PROFILE_SET_DATA = "MODEL_PROFILE_SET_DATA"
export const MODEL_PROFILE_CLEAN_STATE = "MODEL_PROFILE_CLEAN_STATE"
export const MODEL_PROFILE_UPDATE_DATA = "MODEL_PROFILE_UPDATE_DATA"

export const MODEL_PROFILE_UPDATE_FEATURES = "MODEL_PROFILE_UPDATE_FEATURES"

export const MODEL_PROFILE_ADD_GROUP = "MODEL_PROFILE_ADD_GROUP"
export const MODEL_PROFILE_REMOVE_GROUP = "MODEL_PROFILE_REMOVE_GROUP"
